import SuspendOrUnsuspendButton from './SuspendOrUnsuspendButton';

export default SuspendOrUnsuspendButton;